var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contact-info-container" },
    [
      _vm.isKp
        ? [
            _c(
              "div",
              {
                staticClass: "pointer mr-10 flex site-service",
                on: {
                  click: function ($event) {
                    return _vm.toOuterLink(_vm.serviceDeskUrl)
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "icon-pic mr-5",
                  attrs: { src: require("@/assets/img/Icon-OAK.png") },
                }),
                _c("div", { staticClass: "font-bold" }, [
                  _vm._v(_vm._s(_vm.$t("newsMgt.serviceDesk")) + " "),
                  _c("br"),
                  _vm._v("(Roll-forward)"),
                ]),
              ]
            ),
            _c("div", { staticClass: "pointer flex contact-us" }, [
              _c("img", {
                staticClass: "icon-pic mr-5",
                attrs: { src: require("@/assets/img/icon-contact.png") },
              }),
              _c(
                "a",
                {
                  attrs: {
                    target: "_top",
                    href: "mailto:cnfmkpmgclicbt@kpmg.com",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("newsMgt.contactTeam")))]
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }